<template>
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <h1 class="text-center">Bienvenue</h1>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 mt-4 mx-auto">
                  <router-link to="/createcontact" class="card bg-gradient-success height-100 justify-content-center text-center mx-auto">
                      <h6 class="mb-0"> <i class="fa-solid fa-plus text-dark"></i> Créer un contact</h6>
                  </router-link>
                </div>
  
                <div class="col-md-4 mt-4 mx-auto">
                  <router-link to="/contactlist" class="card bg-gradient-info height-100 justify-content-center text-center mx-auto">
                      <h6 class="mb-0"> <i class="fa-solid fa-list text-dark"></i> Liste des contacts</h6>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  